module.exports = __webpack_public_path__ + "img/description-bg.00f7eb5d.png";